import React from "react";
import i18n from "~/assets/js/Helpers/i18n";

const OrderConfirmationCutlery = (cutlery) => {
    const { iconPath } = reactConfig;

    return (
        <div className={`cart-box ${cutlery ? "cutlery__taken" : ""}`}>
            <div className="cart-box__image">
                <img
                    src={`${iconPath}/cutlery-new.svg`}
                    alt="cutlery_knife_fork"
                />
            </div>
            <div className="cart-box__content">
                <div className="cart-box__header">
                    <h5 className="cart-box__title">
                        {i18n.t("cart.cutlery.label")}
                    </h5>
                    <h5 className="cutlery__free">
                        {i18n.t("cart.cutlery.free")}
                    </h5>
                </div>

                <p className="cart-box__text">{i18n.t("cart.cutlery.text")}</p>
            </div>
        </div>
    );
};

export default OrderConfirmationCutlery;
